import api from '@/utils/axios';
import { getUser } from '@/domains/api/users.api';
import { BUSINESS_API_AVAILABLE } from '@/domains/api';
import type {
  CompanyProfile,
  EntityOrder,
  EntityStats,
  EntityType,
  PaginatedResponse,
} from '@/shared/types/company.types';
import {
  getMockProfile,
  getMockOrders,
  getMockStats,
} from '@/domains/company/mock/company.mock';
import { unwrapItem } from '@/utils/apiHelpers';

export async function fetchCompanyProfile(
  userId: number,
  entityType: EntityType,
): Promise<CompanyProfile> {
  try {
    const user = await getUser(userId);
    const profile = (user as unknown as Record<string, unknown>).company_profile;
    if (profile) return profile as CompanyProfile;
  } catch {
    /* fallback mock */
  }
  return getMockProfile(userId, entityType);
}

export async function updateCompanyProfile(
  profileId: number,
  data: Partial<CompanyProfile>,
): Promise<CompanyProfile> {
  if (!BUSINESS_API_AVAILABLE) {
    return { ...getMockProfile(1, data.entity_type ?? 'pme'), ...data, id: profileId };
  }
  const res = await api.patch(`/company-profiles/${profileId}`, data);
  return unwrapItem<CompanyProfile>(res.data);
}

export async function fetchEntityOrders(
  page = 1,
  perPage = 10,
  search = '',
): Promise<PaginatedResponse<EntityOrder>> {
  if (!BUSINESS_API_AVAILABLE) return getMockOrders(page, perPage, search);
  const res = await api.get('/orders', { params: { page, per_page: perPage, search } });
  return res.data;
}

export async function fetchEntityStats(): Promise<EntityStats> {
  if (!BUSINESS_API_AVAILABLE) return getMockStats();
  const res = await api.get('/company/stats');
  return unwrapItem<EntityStats>(res.data);
}
